module.exports = __webpack_public_path__ + "assets-cabinet/img/download-icon.6b763b09.svg";